import React, { useEffect, useReducer } from 'react';
import { useForm } from 'react-hook-form';
// import { useParams, useHistory } from 'react-router';
import { showService } from './showService';
import { ImageUpload } from '../common';
import { Link, useNavigate , useParams  } from 'react-router-dom';
import { useAuth } from '../auth/Authcontext';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2'
import CompetitionTable from './competetionTable';
import ShowImage from './showimg';



const statusOptions = [
    'Draft',
    'PreShow',
    'Active',
    'PostGame',
    'Archived'
]

const initialState = {
    isLoading: true,
    isSubmitting: false,
    isEditting: false,
    show: undefined,
    uploadImage: undefined
}

const ACTIONS = {
    SHOW_GET_CALL: 'SHOW_GET_CALL',
    SHOW_GET_SUCCESS: 'SHOW_GET_SUCCESS',
    SHOW_GET_ERROR: 'SHOW_GET_ERROR',
    TOGGLE_EDIT: 'TOGGLE_EDIT',
    UPDATE_UPLOAD_IMAGE: 'UPDATE_UPLOAD_IMAGE',
    SHOW_UPDATE_CALL: 'SHOW_UPDATE_CALL',
    SHOW_UPDATE_SUCCESS: 'SHOW_UPDATE_SUCCESS',
    SHOW_UPDATE_ERROR: 'SHOW_UPDATE_ERROR'
}

function reducer(state, action) {
    switch (action.type) {
        case ACTIONS.SHOW_GET_CALL:
            return {
                ...state, 
                isLoading: true
            }
        case ACTIONS.SHOW_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                show: {
                    ...action.data
                }
            }
        case ACTIONS.TOGGLE_EDIT:
            let isEditting = !state.isEditting
            return {
                ...state,
                isEditting: isEditting,
                uploadImage: isEditting ? state.uploadImage : undefined
            }
        case ACTIONS.UPDATE_UPLOAD_IMAGE:
            return {
                ...state,
                uploadImage: action.data
            }
        case ACTIONS.SHOW_UPDATE_CALL:
            return {
                ...state,
                isSubmitting: true,
                isLoading: false
            }
        case ACTIONS.SHOW_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                isEditting: true
            }
        case ACTIONS.SHOW_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                isEditting: false,
                show: {
                    ...action.data
                }
            }
        default:
            throw new Error(`No action of type ${action.type} found in reducer.`)
    }
}

function ShowEdit() {

    const { showId } = useParams();
    const [state, dispatch] = useReducer(reducer, initialState);
    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const {contextValue} = useAuth();



    // const history = useHistory();
    const navigate = useNavigate()
    useEffect(() => {
        dispatch({ type: ACTIONS.SHOW_GET_CALL });
        showService.getShow(showId)
        .then(response => dispatch({ type: ACTIONS.SHOW_GET_SUCCESS, data: response.data }))
        .catch(error => console.error(error));
    }, [showId]);

    useEffect(() => {
        if (state.show || !state.isEditting) {
            reset({show: state.show});
        }
    }, [state.show, state.isEditting, reset]);

    function handleEditClick(event) {
        event.preventDefault();
        dispatch({ type: ACTIONS.TOGGLE_EDIT });
    }

    function handleDeleteClick(event) {
        event.preventDefault();
        // if (window.confirm(`This will permanently delete the record for ${state.show.name}, and any asscoiated records such as competitions and scores. There is no way to undo this action. Press 'Ok' if you are sure you want to delete ${state.show.name}.`)) {
        //     showService.deleteShow(showId);
        //     window.alert(`${state.show.name} has been deleted.`);
        //     // history.push('/show');
        //     navigate('/show');
        // }


        const message = `This will permanently delete the record for ${state.show.name}, and any asscoiated records such as competitions and scores. There is no way to undo this action.`

        Swal.fire({
            title: 'Are you sure?',
            text: message,
            // icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            heightAuto: false
          }).then((result) => {
            
            if (result.isConfirmed) {

                contextValue.showLoader();
                contextValue.updateLoaderText("Deleting show...");

                showService.deleteShow(showId).then(response => {
                    toast.success(`${state.show.name} has been deleted.`);
                    navigate('/show');
                })
                .catch(error => {
                    
                    console.error(error);
                    toast.error("Error deleting show");
                })
                .finally(() =>{ 
                    console.log(contextValue)
                    contextValue.hideLoader()});

              // delete logic here
            }
          });



    }

    function handleSaveClick({show}) {
        // dispatch({ type: ACTIONS.SHOW_UPDATE_CALL });
        // showService.updateShow(showId, {
        //     ...show,
        //     FeedImage: state.uploadImage
        // })
        // .then(response => dispatch({ type: ACTIONS.SHOW_UPDATE_SUCCESS, data: response.data }));

        // console.log(state.uploadImage)
        // return;


        contextValue.showLoader();
        contextValue.updateLoaderText("Updating show...");
        dispatch({ type: ACTIONS.SHOW_UPDATE_CALL });

        console.log(show)

        const formData = new FormData();
        const data = show;
        // Append normal text fields
        formData.append("name", data.name);
        formData.append("status", data.status);
        formData.append("WebsiteUrl", data.WebsiteUrl || "");
        formData.append("startDateTime", data.startDateTime);
        formData.append("endDateTime", data.endDateTime);
      
        // Append files (pick the first file from FileList)
        if (data.ThumbImage?.[0]) formData.append("ThumbImage", data.ThumbImage[0]);
        if (data.FeedImage?.[0]) formData.append("FeedImage", data.FeedImage[0]);
        if (data.ResultImage?.[0]) formData.append("ResultImage", data.ResultImage[0]);
        if (data.HeaderImage?.[0]) formData.append("HeaderImage", data.HeaderImage[0]);

        //return
        showService.updateShow(showId, 
            formData
            // ,{
            // ...show,
            // FeedImage: state.uploadImage
            // }
        )
        .then(response => {
            dispatch({ type: ACTIONS.SHOW_UPDATE_SUCCESS, data: response.data })
            toast.success("Show updated successfully");
        })
        .catch(error => {
            toast.error("Error updating show");
            dispatch({ type: ACTIONS.SHOW_UPDATE_ERROR, data: error.response.data })
        })
        .finally(() => contextValue.hideLoader());



    }

    function handleImageUpload(image) {
        dispatch({ type: ACTIONS.UPDATE_UPLOAD_IMAGE, data: image});
    }

    function renderShowImage() {
        let src;
        if (state.uploadImage) {
            src = URL.createObjectURL(state.uploadImage);
        } else if (state.show.feedImagePath) {
            src = `${process.env.REACT_APP_MEDIA_HOST}/${state.show.feedImagePath}`;
        } else {
            src = '/images/horse_image_default.jpg'
        }

        return (
            <img className='m-auto mb-3 w-100 rounded-3' src={src} alt =''/>
        );
    }

    function renderStatusOptions() {
        return statusOptions.map((item) => (
            <option key={`status${item}`} value={item}>{item}</option>
        ));
    }


    return (
        <div className='container h-100 '>
            {!state.isLoading &&
            <>
                <form>
                    <div className='row mb-3'>
                        <h2 className='col'>{state.show.name}</h2>
                        {!state.isEditting &&
                            <div className='col-auto'>
                                <button className='btn btn-primary me-2' onClick={handleEditClick}>Edit</button>
                                <button className='btn btn-danger text-white' onClick={handleDeleteClick}>Delete</button>
                                <Link to={'/competition/upload?showId=' + showId} className='btn btn-primary ms-2'>Upload Competition</Link>

                            </div>
                        }
                        {state.isEditting &&
                            <div className='col-auto'>
                                <button type='submit' className='btn btn-success text-white me-2' onClick={handleSubmit(handleSaveClick)}>Save</button>
                                <button className='btn btn-primary' onClick={handleEditClick}>Cancel</button>
                            </div>
                        }
                    </div>
                    <div className="row">
                        {/* <div className='col-sm col-lg-auto mb-3'>
                            <div className='picture-container m-auto'>
                                {renderShowImage()}
                                {state.isEditting &&
                                    <button type='button' className='btn btn-primary w-100' data-bs-toggle='modal' data-bs-target='#photoUpload'>
                                        Upload Image
                                    </button>
                                }
                                <ImageUpload id='photoUpload' aspectRatio={1.7} onUpload={handleImageUpload}/>
                            </div>
                        </div> */}
                        <div className='col-lg'>
                            <div className='row mb-3'>
                                <div className='col'>
                                    <label htmlFor='showName' className='form-label'>Name:</label>
                                    <input type='text' className='form-control' id='showName' autoComplete='off' {...register('show.name', {required: true})} disabled={!state.isEditting}/>
                                    {errors.show?.name?.type === 'required' && <div className='text-danger form-text'>Name is required</div>}
                                </div>
                                <div className='col'>
                                    <label htmlFor='showStatus' className='form-label'>Status:</label>
                                    <select className='form-select' id='showStatus' autoComplete='off' {...register('show.status')} disabled={!state.isEditting}>
                                        {renderStatusOptions()}
                                    </select>
                                </div>

                                            <div className="col mb-3">
                                    <label htmlFor="newShowWeb" className="form-label">Link to Show's Website</label>
                                    <input type="text" className="form-control" id="newShowWeb"
                                    autoComplete='off' {...register('WebsiteUrl')}/>
                                </div>

                            </div>
                            <div className='row mb-3'>
                                <div className='col mb-3'>
                                    <label htmlFor='showStartDateTime' className='form-label'>Start Date and Time:</label>
                                    <input type='datetime-local' className='form-control' id='showStartDateTime' autoComplete='off' {...register('show.startDateTime')} disabled={!state.isEditting}/>
                                </div>
                                <div className='col mb-3'>
                                    <label htmlFor='showEndDateTime' className='form-label'>End Date and Time:</label>
                                    <input type='datetime-local' className='form-control' id='showEndDateTime' autoComplete='off' {...register('show.endDateTime')} disabled={!state.isEditting}/>
                                </div>
                            </div>

                            <div className='row mb-3'>
                                <div className="col mb-3">
                                <label htmlFor="ThumbImage" className="form-label">Show list image (750w x 500h pixels)</label>
                                    {
                                        state.show.thumbnailImagePath && <ShowImage imgurl={`${process.env.REACT_APP_AWS_S3 + state.show.thumbnailImagePath}`}/>
                                    }
                                    
                                    {
                                        state.isEditting &&  <input type="file" className="form-control mt-2" id="ThumbImage"
                                        {...register('show.ThumbImage')}/>
                                    }
                                
                                </div>
                                <div className="col mb-3">
                                <label htmlFor="FeedImage" className="form-label">Show full page image (750w x 1334h pixels)</label>

                                    <ShowImage imgurl={`${process.env.REACT_APP_AWS_S3 + state.show.feedImagePath}`}/>
                                    {
                                        state.isEditting &&  <input type="file" className="form-control mt-2" id="FeedImage"
                                        {...register('show.FeedImage')}/>
                                    }
                                   
                                </div>

                                 <div className='row mb-3'>
                                    <div className="col">
                                    <label htmlFor="ResultImage" className="form-label">Show results page image (750w x 1334h pixels)</label>

                                        <ShowImage imgurl={`${process.env.REACT_APP_AWS_S3 + state.show.resultImagePath}`}/>
                                        {

                                            state.isEditting &&  <input type="file" className="form-control mt-2" id="ResultImage"
                                            {...register('show.ResultImage')}/>
                                        }
                                      
                                    </div>
                                    <div className="col">

                                    <label htmlFor="HeaderImage" className="form-label">Show header image (750w x 350h pixels)</label>

                                        <ShowImage imgurl={`${process.env.REACT_APP_AWS_S3 + state.show.headerImagePath}`}/>
                                        {
                                            state.isEditting &&  <input type="file" className="form-control mt-2" id="HeaderImage"
                                            {...register('show.HeaderImage')}/>
                                        }
                                       
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <CompetitionTable show={state.show} />
            </>
            }


            
        </div>
    );
}

export default ShowEdit;